import { ButtonBase, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import {
  INTERVIEW_TYPE,
  type InterviewType,
} from "../../WorkerShifts/api/useFetchPaginatedInterviews";

interface InterviewCancelButtonProps {
  isProspectWorkplace: boolean;
  onClick: () => void;
  disabled: boolean;
  interviewType?: InterviewType;
}

export function InterviewCancelButton(props: InterviewCancelButtonProps) {
  const { isProspectWorkplace, onClick, disabled, interviewType } = props;

  // Determine the label based on interview type
  let cancelLabel = "interview";
  if (isProspectWorkplace) {
    cancelLabel = "walk-in";
  } else if (interviewType === INTERVIEW_TYPE.PHONE_SCREEN) {
    cancelLabel = "pre-interview phone call";
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
      {/* TODO: use TextButton instead, once we can override the text color */}
      <ButtonBase
        disabled={disabled}
        sx={{
          width: "auto",
          borderRadius: 0,
        }}
        onClick={onClick}
      >
        <Text
          variant="body1"
          sx={(theme) => ({
            color: theme.palette.error.light,
            borderBottom: "1px solid",
            borderBottomColor: theme.palette.border?.primary,
            paddingBottom: "2px",
            display: "inline-block",
            "&:hover": {
              borderBottomColor: theme.palette.border?.primary,
            },
          })}
        >
          Cancel {cancelLabel}
        </Text>
      </ButtonBase>
    </Stack>
  );
}
